import { FotoBlob } from './../../domain/FotoBlob';
import { Injectable } from '@angular/core';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';

import {
	ServiciosWebServiceProvider
} from '../web-service-service/servicios-web-service';

import * as decode from 'jwt-decode';

import 'rxjs/add/observable/fromPromise';

import { Router } from '@angular/router';

import {
	config, Predicate,
} from 'breeze-client';
@Injectable()
export class AuthenticationService {

	// store the URL so we can redirect after logging in
	redirectUrl: string;

	constructor(private http: HttpClient, private jwtHelperService: JwtHelperService, public sws: ServiciosWebServiceProvider, private router: Router) {

	}

	login(ent, usr, pass) {
		const that = this;
		return this.sws.wsLogin(ent, usr, pass).toPromise()
			.then(function (data) {
				if ((data.res === 1) && (data.lista.length > 0)) {
					that.setToken(data.lista[0].token);
					that.setLastUser(usr);
					that.setLastPass(pass);
					that.setEntidad(ent);
				}
				return data;
			})
			.catch(e => {
				throw e;
			});
	}

	NewToken() {
		const that = this;
		const token = this.getToken();
		if(token){
			const today = new Date();
			const expireData = this.jwtHelperService.getTokenExpirationDate(token);
			const diffMs_FechaUbicacion = (expireData.getTime() - today.getTime()); // milliseconds between now & Christmas
			const diffMins_FechaUbicacion = Math.round(((diffMs_FechaUbicacion % 86400000) % 3600000) / 60000); // minutes
			console.log("*** Token expire in: " + diffMins_FechaUbicacion + " min");

			// Si faltan mas de 10 min para caducar el token no lo renovamos
			if (diffMins_FechaUbicacion > 10) {
				return Promise.resolve(token);
			}

			return this.sws.wsNewToken(token).toPromise()
			.then(function (data) {
				const today = new Date();
				const expireData = that.jwtHelperService.getTokenExpirationDate(data);
				const diffMs_FechaUbicacion = (expireData.getTime() - today.getTime()); // milliseconds between now & Christmas
				const diffMins_FechaUbicacion = Math.round(((diffMs_FechaUbicacion % 86400000) % 3600000) / 60000); // minutes
				console.log("*** New Token: " + data + "\n New Token expire in: " + diffMins_FechaUbicacion + " min");
				if (data.length > 0) {
					that.setToken(data);
				}
				return data;
			})
			.catch(e => {
				throw e;
			});
		}

	}

	relogin() {
		const ent = this.getEntidad();
		const usr = this.getLastUser();
		const pass = this.getLastPass();
		return this.NewToken();
	}

	public setHeaderToken() {
		// Provider replacement
		const ajaxAdapter = <any>config.getAdapterInstance('ajax', 'angular');

		// Default authentication settings
		const headers = ajaxAdapter.defaultSettings['headers'] || {};
		const token = this.getToken();

		headers['Authorization'] = 'Bearer ' + token;
		ajaxAdapter.defaultSettings['headers'] = headers;
	}

	public isAuthenticated(): boolean {
		const token: string = this.jwtHelperService.tokenGetter();
		const user: string = this.getLastUser();
		const pwd: string = this.getLastPass();
		const ent: string = this.getEntidad();

		if (!token || !user || !pwd || !ent) {

			return false;
		}
		else {
			return !this.estaTokenExpirado();
		}

		// No controlamos si el token está expirado. De ello se encarga el propio servicio.
		// 15/03/2018: es mejor controlar localmente tb la expiración. Si no pasa frecuentemente que si abandonas la app sin hacer logout y abres (por ejemplo) al
		// día siguiente de nuevo la app, se accede del tirón sin pasar por la pantalla de login, que sería lo correcto.
		// const tokenExpired: boolean = this.jwtHelperService.isTokenExpired(token);
		// return !tokenExpired;
	}

	estaTokenExpirado(){
		const token: string = this.jwtHelperService.tokenGetter();
		const tokenExpired: boolean = this.jwtHelperService.isTokenExpired(token);
		return tokenExpired;
		// return true; // Fixme
	}

	public getToken(): string {
		const token: string = this.jwtHelperService.tokenGetter();
		return token;
	}

	public setToken(token: string) {
		localStorage.setItem('token', token);
		this.setHeaderToken();
	}

	public getIdUsuario() {
		// decode the token to get its payload
		const token = this.getToken();
		if (!token) {
			return '';
		}
		const tokenPayload = decode(token);
		return tokenPayload.nameid;
	}

	public getIdEntidad() {
		// decode the token to get its payload
		const token = this.getToken();
		if (!token) {
			return '';
		}
		const tokenPayload = decode(token);
		return tokenPayload.primarygroupsid;
	}

	public getIdApp() {
		// decode the token to get its payload
		const token = this.getToken();
		if (!token) {
			return '';
		}
		const tokenPayload = decode(token);
		return tokenPayload.system;
	}

	public getRole() {
		// decode the token to get its payload
		const token = this.getToken();
		if (!token) {
			return '';
		}
		const tokenPayload = decode(token);
		return tokenPayload.role;
	}

	public getLastUser(): string {
		return localStorage.getItem('user');
	}

	public setLastUser(user: string) {
		localStorage.setItem('user', user);
	}

	public getLastPass(): string {
		return localStorage.getItem('pass');
	}

	public setLastPass(pass: string) {
		localStorage.setItem('pass', pass);
	}

	public getEntidad() {
		return localStorage.getItem('Entidad');
	}

	public setEntidad(Entidad: string) {
		localStorage.setItem('Entidad', Entidad);
	}

	public getIdEspacio() {
		return localStorage.getItem('IdEspacio');
	}

	public setIdEspacio(Entidad: string) {
		localStorage.setItem('IdEspacio', Entidad);
	}

	public setAreaEspacio(Entidad: string) {
		localStorage.setItem('AreaEspacio', Entidad);
	}

	public getAreaEspacio() {
		return localStorage.getItem('AreaEspacio');
	}

	public getFotoPorDefecto() {
		return 'assets/itsoft/images/no-contenidos-p.png';
		// return localStorage.getItem('FotoPorDefecto');
	}

	public getFotoBlobPorDefecto() {
		return new FotoBlob();
	}

	public setFotoPorDefecto(fotoBlob) {
		const json = JSON.stringify(fotoBlob);
		return localStorage.setItem('FotoPorDefecto', fotoBlob);
	}

	public logout(): void {
		localStorage.removeItem('token');
		localStorage.removeItem('IdEspacio');
		localStorage.removeItem('user');
		localStorage.removeItem('pass');
		localStorage.removeItem('Entidad');
		localStorage.removeItem('FotoPorDefecto');
	}

	redirigirNoLogado(): boolean {
		const logado = this.isAuthenticated();
		// console.log(this.router.url + ' estaLogado: ' + logado);
		const noLogin =  this.router.url.indexOf('/Login') === -1;

		if (!logado && this.router.url !== '/' && noLogin && this.router.url.split('?')[0] !== '/DescargaApp' ) {
			// this.logout();
			this.router.navigate(['/']);
		}
		return logado;
	}

	/* Filtros Busqueda Contenido */
	public getFiltroContenido(): any {
		const valor = localStorage.getItem('FiltroContenido');

		const filtro = valor ? JSON.parse(valor) : {
														where: {
															Titulo: '',
															estado: '3', // ACTIVO
															expirado: new Predicate('FechaAlta', '>=', '1900-01-01'),
															Desde: '',
															Hasta: '',
															ElementoAsignado: '',
															IdAlternativo: '',
															Tipologia: ''
														},
														order: 'Titulo desc',
														top: 10,
														page: 0,
														total: 0
													};

		return filtro;
	}

	public setFiltroContenido(filtro: string) {
		localStorage.setItem('FiltroContenido', JSON.stringify(filtro));
	}

	public resetFiltroContenido() {
		const valor = {
				where: {
				Titulo: '',
				estado: '3', // ACTIVO
				expirado: new Predicate('FechaAlta', '>=', '1900-01-01'),
				Desde: '',
				Hasta: '',
				ElementoAsignado: '',
				IdAlternativo: '',
				Tipologia: ''
			},
			order: 'Titulo desc',
			top: 10,
			page: 0,
			total: 0
		};

		localStorage.setItem('FiltroContenido', JSON.stringify(valor));
	}
	public setRutaSugerida(rutaId) {
		localStorage.setItem('rutaId', rutaId);
	}
	public getRutaSugerida(): any {
		const rutaId = localStorage.getItem('rutaId');
		return rutaId;
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/authentication/authentication.service.ts